import { axiosInstance } from './ApiConfig';
import handleInputChange from '../function/HandleInputsChange';

async function loadConfiguration(
  launchId,
  inputs,
  setInputs,
  setOptions,
  setCrmInfo,
  setInitNbrWindings
) {
  try {
    const returns = Object.keys(inputs);

    const { data } = await axiosInstance({
      method: 'POST',
      url: `/load/${launchId}`,
      data: { returns },
    });

    const { results } = data;
    Object.entries(results).forEach(([key, value]) => {
      if (key === 'crm_info') setCrmInfo(value);
      else if (key === 'nbr_windings') setInitNbrWindings(value);
      else handleInputChange(key, value, inputs, setInputs, setOptions);
    });
    return data;
  } catch (error) {
    console.error('Error loading configuration:', error);
  }
}

export default loadConfiguration;
